import React from 'react';
import FormROValue from "../../../library/form/components/FormROValue1"
import FormInput from "../../../library/form/components/FormInput"
import FormLink from "../../../library/form/components/FormLink"
import FormButton from "../../../library/form/components/FormActionButton2"
import FormWrapper from '../../../library/form/components/FormWrapper';

const InvItemChildGroupRow = (props) => {
    const { formObject, rowKey, isUOM2 } = props;

    return (
        <li className="uiSearchRow">
            <ul>
                <li className="uiColumnCenter uiColumn150">
                <FormLink formObject={formObject} rowKey={rowKey} className="uiLink"
                        action={{
                            paramName: "refId",
                            actionId: "show",  actionName: "invcomp",
                            containerKey: "popup"
                        }}
                        linkProp={{ target: "_blank" }}
                ></FormLink>
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "docDate" }} />
                </li>
                <li className="uiColumnCenter uiColumn70">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "sih" }} />
                </li>
                <li className="uiColumnCenter uiColumn100">
                    <FormROValue format="#" formObject={formObject} rowKey={rowKey} action={{ paramName: "unitPrice" }} />
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit"
                        action={{ InputType: "input", actionId: "refresh", refreshMode: "dep", paramName: "qty1", actionParam:{formulaSource: "QT1", "saveChildQty":1} }} />
                </li>
                <li className="uiColumnCenter uiColumn50">
                    <FormInput formObject={formObject} rowKey={rowKey} className="uiInput widthInherit" style={{display: isUOM2?"":"none"}}
                        action={{ InputType: "input", actionId: "refresh", refreshMode: "dep", paramName: "qty2", actionParam:{formulaSource: "QT2", "saveChildQty":1} }} />
                </li>
                <FormWrapper customWrapper="li" formObject={formObject} headerKey="headerRows" wrapperClass="uiColumnCenter uiColumn50" action={{ paramName: "ccLabel" }} >
                    <FormROValue format="" formObject={formObject} rowKey={rowKey} action={{ paramName: "ccQty" }} className="uiValue uiBlue" />
                </FormWrapper>
                <li className="uiColumnCenter uiColumn50 phViewAction uiActionBlock">
                    <FormButton formObject={formObject} rowKey={rowKey} 
                    starIcon="edit"
                    onlyIcon={true}
                    tooltip="Edit"
                    starIconClassName="uiColorNeutralAction"
                    className="" 
                        action={{ actionId: "edit", paramName: "editBtn",  actionParam: { pathKey:"#pathKey" }, containerKey: "popup" }}
                        ></FormButton>
                    <FormButton formObject={formObject} rowKey={rowKey}
                    starIcon="clear"
                    onlyIcon={true}
                    tooltip="Delete"
                    starIconClassName="uiColorNegativeAction"
                    className=""
                        action={{ actionId: "del", paramName: "delBtn", actionParam: {}, containerKey: "row" }}
                    ></FormButton>
                </li>
            </ul>
        </li>
    )
}

export default InvItemChildGroupRow